<template>
  <div class="tw-relative" v-if="activeNotifications[notificationKey]">
    <c-banner :type="activeNotifications[notificationKey].type">
      <q-badge
        v-if="activeNotifications[notificationKey].counter > 1"
        rounded
        :color="badgeColor"
        floating
        >{{ activeNotifications[notificationKey].counter }}</q-badge
      >
      {{ activeNotifications[notificationKey].message }}
    </c-banner>
  </div>
</template>

<script setup>
import { useNotifyStore } from "store/modules/notifyStore.js";
import { storeToRefs } from "pinia";
import { computed } from "vue";

const props = defineProps({
  notificationKey: {
    type: String,
    required: true,
  },
});

const notifyStore = useNotifyStore();
const { activeNotifications } = storeToRefs(notifyStore);

const badgeColor = computed(() => {
  return activeNotifications.value[props.notificationKey].type === "error" ||
    activeNotifications.value[props.notificationKey].type === "negative"
    ? "red"
    : activeNotifications.value[props.notificationKey].type === "positive" ||
        activeNotifications.value[props.notificationKey].type === "success"
      ? "green-10"
      : "primary";
});
</script>
